import axios from 'axios'

// To update the auth token, go to https://dev.azure.com/arrowstorm/_usersSettings/tokens and create a new token with "Code (read)" permissions

export default {
  organization: 'arrowstorm',
  project: 'FieldService',
  repositoryId: 'OfficeWeb',
  authToken:
    '54hse4VEfNwmCRoDrPULcRukiUGiZfOVVqsiHresSVaejWk7JTHvJQQJ99CEACAAAAA6NBVvAAASAZDO4ay6',

  getRepoHistory() {
    const url = `https://dev.azure.com/${this.organization}/${this.project}/_apis/git/repositories/${this.repositoryId}/commits?api-version=5.1`
    return axios.get(url, {
      auth: {
        password: this.authToken
      }
    })
  }
}
